import {app} from '../../../../../app';
import {Controller} from './edit-policy.controller';

app.component('companyPoliciesAuthenticationAccessPoliciesEdit', {
    bindings: {
        browserTypes: '<',
        companyId: '<',
        countries: '<',
        defaultPolicy: '<',
        osTypes: '<',
        policy: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-policy.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/edit-policy/edit-policy.component.js